import { Box, Typography } from "@mui/material";
import { Show, TabbedShowLayout, useRecordContext, useTranslate } from "react-admin";

import { avatarSize, borderRadius, space, typography } from "../theme/designTokens";
import { UnenrollDeviceButton } from "./deviceEnrollment/UnenrollDeviceButton";
import { DeviceInfoPanel } from "./DeviceInfoPanel";

export interface DeviceRecord {
  id: string;
  name?: string;
  deviceId?: string;
  status?: string;
  unenrolledAt?: string | null;
  manufacturer?: string;
  model?: string;
  osVersion?: string;
  appVersion?: string;
  contentVersion?: string;
  location?: {
    name?: string;
  };
}

const DeviceAvatar = () => {
  return (
    <Box
      component="img"
      src="/device.png"
      alt="Device"
      sx={{
        width: avatarSize.lg,
        height: avatarSize.lg,
        borderRadius: borderRadius.lg,
        objectFit: "cover",
      }}
    />
  );
};

const DeviceShowActions = () => {
  const record = useRecordContext<DeviceRecord>();

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: `${space.xs}px`, mb: `${space.xs}px` }}>
      <DeviceAvatar />
      <Typography
        variant="h5"
        component="h1"
        sx={{ fontWeight: typography.fontWeight.medium, minWidth: 0, overflowWrap: "anywhere", flex: 1 }}
      >
        {record?.name}
      </Typography>
      {record && (
        <Box sx={{ ml: "auto", width: { xs: "100%", sm: "auto" } }}>
          <UnenrollDeviceButton device={record} />
        </Box>
      )}
    </Box>
  );
};

const DeviceShow = () => {
  const translate = useTranslate();

  return (
    <Show actions={<DeviceShowActions />}>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label={translate("tabs.information")}>
          <DeviceInfoPanel />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default DeviceShow;
